import { Outlet } from "react-router-dom";
import UserManagementMenu from "../../components/UserManagementMenu";
import { UserManagementContainer } from "./style";

export const UsersManagement = () => {
  return (
    <>
      <UserManagementContainer>
        <UserManagementMenu />
      </UserManagementContainer>
      <Outlet />
    </>
  );
};
